<template>
  <div class="login_box">
    <div class="avatar_box" :style="forgetPwd ? '' : 'margin: 0 0 100px'">
      <img src="@/assets/images/icon.png" alt="" style="height: 25px;">
      <span>后台管理系统</span>
      <!-- <p>Background Management System</p> -->
    </div>
    <div v-if="!forgetPwd">
      <!-- 登录表单 -->
      <!-- <el-tabs @tab-click="forgetPwd = false" v-model="activeName"> -->
      <!-- <el-tab-pane label="密码登录" name="first"> -->
      <PasswordLogin @ChangeForgetPwd="ChangeForgetPwd" @isLogin="isLogin" v-if="isShow === 0" />
      <!-- </el-tab-pane> -->
      <!-- <el-tab-pane label="快捷登录" name="second" class="quick-load"> -->
      <PhoneLogin @isLogin="isLogin" v-if="isShow === 1" />
      <!--      扫码登录-->
      <QrcodeLogin ref="QrcodeLogin" v-if="isShow === 2" />
      <!-- </el-tab-pane> -->
      <!-- </el-tabs> -->
    </div>
    <ForgetPwd @ChangeForgetPwd="ChangeForgetPwd" v-if="forgetPwd" />
    <div class="btn">
      <p @click="isShow = 0, forgetPwd = false">使用密码登录</p>
      <p>|</p>
      <p @click="isShow = 1, forgetPwd = false">使用快捷登录</p>
      <p>|</p>
      <p @click="isShow = 2, forgetPwd = false, saoma()">使用扫码登录</p>
    </div>
  </div>
</template>

<script>
import QrcodeLogin from './QrcodeLogin.vue'
import ForgetPwd from './ForgatPwd.vue'
import PasswordLogin from './PasswordLogin.vue'
import PhoneLogin from './PhoneLogin.vue'
import { socialLoginWeixin } from '@/api/crm'
export default {
  components: {
    PasswordLogin, PhoneLogin, ForgetPwd, QrcodeLogin
  },
  data () {
    return {
      isShow: 0,
      forgetPwd: false,
      activeName: 'first'
      // 快捷登录

    }
  },
  created () {
    let _this = this
    document.onkeydown = function (e) {
      var key = window.event.keyCode
      if (key === 13) {
        if (_this.forgetPwd) {
          _this.forgetPwdLogin()
        } else if (_this.activeName === 'first') {
          _this.login()
        } else if (_this.activeName === 'second') {
          _this.quickLogin()
        }
      }
    }
  },
  watch: {
    $route: {
      handler (val, oldVal) {
        console.log(val)
        if (val.query.code) {
          this.isShow = 2
          this.$nextTick(_ => {
            this.$refs.QrcodeLogin.scanCodeClick()
            // this.$refs.QrcodeLogin.show()
          })

          socialLoginWeixin({
            code: val.query.code,
            type: 'ADMIN'
          })
            .then(res => {
              if (res.data.success) {
                this.isLogin(res)
              } else {
                this.$nextTick(_ => {
                  this.$refs.QrcodeLogin.show()
                })
              }
            })
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {

  },
  methods: {
    saoma () {
      if (this.isShow === 2) {
        this.$nextTick(_ => {
          this.$refs.QrcodeLogin.scanCodeClick()
        })
      }
    },
    ChangeForgetPwd (val) {
      console.log(val)
      this.forgetPwd = val
    },

    isLogin (res) {
      console.log('resres', res)
      this.$message({
        message: '登录成功',
        type: 'success'
      })
      window.localStorage.setItem('token', res.data.access_token)
      window.localStorage.setItem('key', res.data.roleId)
      window.localStorage.setItem('access_token', res.data.access_token)
      window.localStorage.setItem('accessTokenExpiry', res.data.accessTokenExpiry)
      window.localStorage.setItem('refresh_token', res.data.refresh_token)
      window.localStorage.setItem('refreshTokenExpiry', res.data.refreshTokenExpiry)
      window.localStorage.setItem('key', res.data.roleId)
      window.localStorage.setItem('userId', res.data.userId)
      this.$store.commit('user/changeIsLogin', true)
      this.$store.dispatch('user/getList', '/hqsyshome')
      this.$store.commit('user/changeUserMsg', [res.data.userId, res.data.storeId, res.data.userType, res.data.storeCode, res.data.storeName])
    }

  }
}
</script>

<style lang="less">
@deep: ~">>>";
// 样式很乱，有问题推荐重写

.login_container {
  // background: url("https://data.piyaps.com/web-image/70061/6db8b8897f0d7273a48f83f8c738692c.png") no-repeat center;
  background: url("../../assets/images/new-bg.png");
  height: 94%;
  background-size: 100% 100%;
}

.btn {
  height: 22px;
  padding-top: 30px;
  width: 60%;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: Source Han Sans CN, Source Han Sans CN-Normal;
  font-weight: normal;
  text-align: left;
  color: #356fcf;

  p {
    cursor: pointer;
    margin-right: 10px;
  }
}

.login_box {
  position: absolute;
  top: 180px;
  right: 18%;

  .forget_password {
    font-size: 14px;
    font-family: Source Han Sans CN, Source Han Sans CN-Normal;
    font-weight: normal;
    text-align: right;
    color: #356fcf;
    margin-bottom: 50px;
    cursor: pointer;
  }

  .forget-title {
    opacity: 1;
    font-size: 28px;
    font-family: Source Han Sans CN, Source Han Sans CN-Bold;
    font-weight: 700;
    text-align: left;
    margin: 0 0 10px 29px;
  }

  .forget-text {
    font-size: 14px;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    text-align: left;
    color: #505050;
    // margin: 0 0 15px 29px;
    margin: 20px 0 60px;
  }

  .login_from {
    width: 557px;
    box-sizing: border-box;
    margin: 0 auto;

    .el-input {
      width: 100%;
      margin-right: 0;
    }

    .el-form-item {
      display: flex;
      flex-flow: column;
      margin-bottom: 10px;
    }

    .el-form-item__label {
      text-align: left;
      font-size: 16px;
      font-family: Source Han Sans CN, Source Han Sans CN-Normal;
      font-weight: normal;
      color: #000000;
    }

    .el-form-item__content {
      margin-left: 0px !important;
    }

    .el-input__inner {
      height: 48px !important;
      line-height: 48px !important;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Normal;
      font-weight: normal;
      text-align: left;
      color: #000;
      padding: 0 17px;
      border: 0.5px solid #476ea446 !important;
      border-radius: 6px !important;
    }

    .is-error .el-input__inner {
      border: 1px solid #dcdfe6;
    }

    .el-form-item__error2 {
      position: absolute;
      right: 0;
      bottom: -20px;
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
    }
  }

  .verification-code {
    .el-input {
      width: 404px;
    }

    .el-button {
      float: right;
      line-height: 48px;
      border: 1px solid #eee;
      padding: 0;
      text-align: center;
      height: 48px !important;
      width: 138px;
      background: #0052d9;
      border-radius: 6px;

      span {
        color: #fff;
      }
    }

    .bg-text {
      background: #ccc;
    }
  }

  .login_btn {
    width: 557px;
    margin-top: 25px;

    button {
      display: block;
      width: 100%;
      background: #0052d9;
      border-radius: 6px;
      color: #fff;
      height: 48px !important;
      padding: 0;
      box-shadow: none;
      border: none;
      cursor: pointer;

      span {
        font-size: 18px;
      }

      &:hover {
        opacity: 0.65;
      }
    }
  }

  .forget_password {
    font-size: 14px;
    font-family: Source Han Sans CN, Source Han Sans CN-Normal;
    font-weight: normal;
    text-align: right;
    color: #356fcf;
    cursor: pointer;
  }
}

.avatar_box {
  // margin: 0 0 100px;
  // text-align: center;
  display: flex;
  align-items: center;

  span {
    // line-height: 50px;
    font-size: 26px;
    font-family: Source Han Sans CN, Source Han Sans CN-Medium;
    font-weight: 500;
    // text-align: left;
    color: #000000;
    margin-left: 10px;
  }

  // p {
  //   font-size: 12px;
  //   color: #999;
  //   letter-spacing: 0;
  // }
}

@{deep} .el-tabs__nav-wrap {
  &:after {
    display: none;
  }

  .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
  }

  .el-tabs__item {
    color: #999;
    font-size: 18px;
  }

  .el-tabs__item.is-active {
    color: #333;
  }

  .el-tabs__active-bar {
    background: #999;
    height: 4px;
    width: 17px !important;
    left: 27px;
  }
}
</style>
